import { render, staticRenderFns } from "./DeliveredMailTable.vue?vue&type=template&id=71880077"
import script from "./DeliveredMailTable.vue?vue&type=script&lang=js"
export * from "./DeliveredMailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports